'use client';

import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { filaStore } from '@/infrastructure/store/filaStore';

export function useFila() {
  return useStore(
    filaStore,
    useShallow((s) => ({
      fila: s.fila,
      historico: s.historico,
      historicoDia: s.historicoDia,
      mudancasHoje: s.mudancasHoje,
      mudancasLoading: s.mudancasLoading,
      mudancasFailed: s.mudancasFailed,
      loading: s.loading,
      failed: s.failed,
      historicoLoading: s.historicoLoading,
      historicoFailed: s.historicoFailed,
      applyingUid: s.applyingUid,
      applyingLote: s.applyingLote,
      desfazendoDecisao: s.desfazendoDecisao,
      ignoradas: s.ignoradas,
      ignoradasLoading: s.ignoradasLoading,
      ignoradasFailed: s.ignoradasFailed,
      loadFila: s.loadFila,
      loadHistorico: s.loadHistorico,
      loadMudancasHoje: s.loadMudancasHoje,
      loadIgnoradas: s.loadIgnoradas,
      sugestaoDeReforco: s.sugestaoDeReforco,
      aplicar: s.aplicar,
      aplicarEmLote: s.aplicarEmLote,
      desfazerDecisao: s.desfazerDecisao,
      previaCobranca: s.previaCobranca,
    })),
  );
}
